import { useTranslation } from 'react-i18next';

/** Пять ролей сотрудников Treejar (ТЗ v3.1 п.1) и их подписи из i18n. */
export const STAFF_ROLES = ['admin', 'partner_manager', 'project_manager', 'finance', 'viewer'] as const;
export type StaffRole = (typeof STAFF_ROLES)[number];

export function useRoleLabels(): Record<string, string> {
  const { t } = useTranslation();
  return {
    admin: t('set.roleAdmin'),
    partner_manager: t('set.rolePartner'),
    project_manager: t('set.roleProject'),
    finance: t('set.roleFinance'),
    viewer: t('set.roleViewer'),
  };
}
